import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { User } from '../../entities/user';
import { Pagination } from '../../entities/pagination';
import { strings } from '../../localization/strings';
import PaginationComponent from '../common/pagination';

interface ComponentProps {
  users: User[];
  pagination: Pagination;
  onUpdate: (pageNo: number) => void;
  editPathBase?: string;
  showCompany?: boolean;
}

export default function UsersTableComponent({
  users,
  pagination,
  onUpdate,
  editPathBase,
  showCompany,
}: ComponentProps) {
  const getPrimaryLinkLabel = (user: User) => {
    return user.email || user.username || user.name || strings.users.list.noEmail;
  };

  return (
    <>
      <div className="flex flex-col">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-4 lg:px-8">
            <div className="overflow-hidden border-b border-gray-200">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                    >
                      {strings.users.list.email}
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                    >
                      {strings.users.list.name}
                    </th>
                    {showCompany && (
                      <th
                        scope="col"
                        className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                      >
                        {strings.users.list.company}
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {users.map((user, index) => (
                    <tr
                      key={user.id}
                      className={classNames(
                        user.is_active === 0 ? 'bg-red-50' : '',
                        user.is_active && index % 2 === 0 ? 'bg-white' : 'bg-gray-50',
                      )}
                    >
                      <td className="px-4 py-3 text-sm text-gray-900">
                        <Link to={`${editPathBase}/${user.id}`} className="text-indigo-600 hover:text-indigo-900">
                          {getPrimaryLinkLabel(user)}
                        </Link>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600">{user.name}</td>
                      {showCompany && (
                        <td className="px-4 py-3 text-sm text-gray-600">
                          {user.company ? (
                            <Link
                              to={`/companies/view/${user.company.id}`}
                              className="text-indigo-600 hover:text-indigo-900"
                            >
                              {user.company.name}
                            </Link>
                          ) : (
                            '-'
                          )}
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <PaginationComponent pagination={pagination} onChangePage={onUpdate} />
    </>
  );
}

UsersTableComponent.defaultProps = {
  editPathBase: '/users/edit',
  showCompany: true,
};
